import { type QueryClient, useQuery } from '@tanstack/react-query'
import { getInvoiceSummary } from './endpoints'

const QueryKeys = {
  customerInvoice: (customerId: string) => ['customerInvoice', customerId] as const,
}

export const invalidateCustomerInvoice = ({ queryClient, customerId }: { queryClient: QueryClient; customerId: string }) => {
  queryClient.invalidateQueries({ queryKey: QueryKeys.customerInvoice(customerId) })
}

export const useCustomerInvoice = (customerId: string) => {
  return useQuery({
    queryKey: QueryKeys.customerInvoice(customerId),
    queryFn: () => getInvoiceSummary(customerId),
  })
}
